import React from 'react'
import HttpRequest from "../../../HttpRequest";
import {Tools} from "../../../Tools";
import Loader from "../../../components/Loader";
import ErrorPage from "../../../components/ErrorPage";
import {default as Links} from "../../../Route";
import Components from "../../../components";
import MessageBuilder from "../../../components/MessageBuilder";


const
    formFields = {
        contributorId: "",
        contributionId: "",
        paymentMode: "",
        amount: ""
    },
    disabledAttribute = {
        disabled: "disabled",
    },
    addButtons = {
        id: "",
        set: {
            label: "Enrégistrer le paiement",
            action: "POST",
            attributes: disabledAttribute,
        }
    },
    loadingInButton = (<><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"/>Waiting...</>),
    fieldsToActiveSubmitButton = ["contributorId", "contributionId", "paymentMode", "amount"]
;

class ContributionsSave extends React.Component{

    constructor(props) {
        super(props);

        this.handleButtonClicked = this.handleButtonClicked.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.httpClient = new HttpRequest();
        this.state = {
            server: {},
            isLoadCompleted: false,
            hasPageError: false,
            hasError: false,
            contributionSaved: false,
            currentType: "",
            form: {
                fieldValues: Tools.Clone(formFields),
                fieldLabels: Tools.Clone(formFields),
                buttons: Tools.Clone(addButtons),
                currentType: ""
            }
        };
        this.formRef = React.createRef();
        this.cancelEventsRef = React.createRef();

    }

    handleChange(field, event){
        let form = this.state.form;
        form.fieldValues[field] = event.target.value;

        // On definit les champs obligatoire pour le bouton "enregistrer" du formulaire ne soit pas grisé
        let fieldsRequire = Tools.Clone(fieldsToActiveSubmitButton);

        // On compte les champs requise non vide
        let count = 0;
        fieldsRequire.forEach(function (key) {
            if(form.fieldValues[key]){
                count++;
            }
        });

        if(field === "contributionId"){
            if(!form.fieldValues[field] || form.fieldValues[field] === ""){
                this.cancelEventsRef.current.classList.add("cancel-events");
            }
            else{
                this.cancelEventsRef.current.classList.remove("cancel-events");
                const contribution = this.state.contributions.find((contribution) => {return contribution.id === parseInt(form.fieldValues[field])});
                form.fieldValues["amount"] = contribution.amount;
            }
        }
        
        // Si le nombre de champs requise non vide correspond au nombre de champ requis, on dégrise le bouton "enrégistrer"
        form.buttons["set"].attributes = (count === fieldsRequire.length ? null : disabledAttribute);

        this.setState({form: form});
    }

    handleButtonClicked(event){
        // Here we add the loader in the button
        let form = this.state.form, newButtonLoader = Tools.Clone(addButtons);
        newButtonLoader["set"].label = loadingInButton;
        newButtonLoader["set"].attributes = disabledAttribute;
        form.buttons = newButtonLoader;
        this.setState({form: form});

        let data = {
            ...this.state.form.fieldValues,
        };

        // Call to the API
        const _self = this;
        this.httpClient.request(Links.APIPaymentsContributionsSave, "PATCH", {}, data).then(function (response){
            _self.server = response;
            let state = {server: response, form: form, showAlert: true, hasAsyncError: false};
            if(_self.server.code === 200){
                // We reset form
                //form.fieldValues = Tools.Clone(formFields);
                state = {contributionSaved: true};
            }
            form.buttons = addButtons;
            form.buttons.set.attributes = null;
            _self.setState({...state});
        }).catch(function (error){
            _self.server = error;
            form.buttons = addButtons;
            form.buttons.set.attributes = null;
            _self.setState({server: error, form: form, showAlert: true, hasAsyncError: true});
        });
    }

    handleSubmit(event){
        event.preventDefault();
    }

    render(){
        if(Tools.IsEmpty(this.beneficiaryOptions) && this.state.beneficiaries){
            this.beneficiaryOptions = this.state.beneficiaries.map((item) => {
                return <Components.Option key={"beneficiaries-" + item.id} data={{
                    value: item.id,
                    label: item.label,
                }} />
            });
        }
        if(Tools.IsEmpty(this.paymentMode) && this.state.paymentMode){
            this.paymentModeOptions = this.state.paymentMode.map((item) => {
                return <Components.Option key={"paymentMode-" + item.id} data={{
                    value: item.id,
                    label: item.label,
                }} />
            });
        }
        if(Tools.IsEmpty(this.contributionsOptions) && this.state.contributions){
            this.contributionsOptions = this.state.contributions.map((item) => {
                return <Components.Option key={"contributions-" + item.id} data={{
                    value: item.id,
                    label: item.label,
                }} />
            });
        }

        let fieldLabels = Tools.Clone(this.state.form.fieldLabels);
        Object.keys(fieldLabels).forEach((key) => {
            if(this.state.contribution_save_form && this.state.contribution_save_form.hasOwnProperty(key)){
                const field = this.state.contribution_save_form[key];
                fieldLabels[key] = field.label + (field.require === true && key !== "title" && key !== "contributions" ? " *" : "");
            }
        });



        let element, messageElement = "";
        if(!this.state.isLoadCompleted){
            element = <Loader />;
        }
        else if(this.state.hasError){
            const text = this.state.server && this.state.server.message ? "<h1>"+ this.state.server.message +"</h1>" : "";
            element = <ErrorPage data={{content: text}} />;
        }
        else {
            if(this.state.showAlert || this.state.contributionSaved){
                let content = null,
                    messageBuilder = MessageBuilder.create(),
                    alertClass = Components.Dialogs.ALERT_TYPES.DANGER;

                if(this.state.hasAsyncError){
                    content = "Nos serveurs sont en maintenance. Revenez ultérieurement!";
                }
                else{
                    if(this.server.data && this.server.data.hasOwnProperty("fields_error")){
                        Object.keys(this.server.data.fields_error).forEach((field) => {
                            messageBuilder.addMessage(this.server.data.fields_error[field].label);
                        });
                        content = messageBuilder.getMessage();
                    }
                    if(!content && this.server.message){
                        content = this.server.message;
                    }
                    if(this.state.contributionSaved){
                        alertClass = Components.Dialogs.ALERT_TYPES.SUCCESS;
                    }
                }
                messageElement = <Components.Dialogs.AlertDialog  data={{content: content, iconClass: "", alertClass: alertClass}} />;
            }
            element = (
                <div className="row">
                    <div className="col-md-12">
                        {messageElement}
                        <form className="mt-6" ref={this.formRef} onSubmit={this.handleSubmit} encType="multipart/form-data">
                            <div className="row">
                                <div className="col-md-6 mb-3">
                                    <label htmlFor="contributions">{fieldLabels.contributionId}</label>
                                    <select id="contributions" name="contributions" className="form-control input-contributions input-lg" required onChange={this.handleChange.bind(this, "contributionId")} value={this.state.form.fieldValues.contributionId}>
                                        {this.contributionsOptions}
                                    </select>
                                </div>
                                
                                <div className="col-md-6 mb-3">
                                    <label htmlFor="title">{fieldLabels.contributorId}</label>
                                    <select id="contributorId" name="contributorId" className="form-control input-contributorId input-lg" required onChange={this.handleChange.bind(this, "contributorId")} value={this.state.form.fieldValues.contributorId}>
                                        {this.beneficiaryOptions}
                                    </select>
                                </div>
                            </div>

                            <div id="cancel-events" className="cancel-events" ref={this.cancelEventsRef}>
                                <div className="row">
                                    <div className="col-md-6 mb-3">
                                        <label htmlFor="amount">{fieldLabels.amount}</label>
                                        <input id="amount" name="amount" type="number" min="0" placeholder="Ex: 5000" className="form-control input-amount input-lg" required onChange={this.handleChange.bind(this, "amount")} value={this.state.form.fieldValues.amount} />
                                    </div>
                                    <div className="col-md-6 mb-3">
                                        <label htmlFor="paymentMode">{fieldLabels.paymentMode}</label>
                                        <select id="paymentMode" name="paymentMode" className="form-control input-paymentMode input-lg" required onChange={this.handleChange.bind(this, "paymentMode")} value={this.state.form.fieldValues.paymentMode}>
                                            {this.paymentModeOptions}
                                        </select>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-md-4 mb-3">
                                        <button className="btn btn-primary btn-lg btn-block mt-6" type="submit" {...this.state.form.buttons.set.attributes} onClick={this.handleButtonClicked}
                                                data-id={this.state.form.buttons.id} data-action={this.state.form.buttons.set.action}>{this.state.form.buttons.set.label}</button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            );
        }

        return element;
    }


    componentDidMount() {
        const _self = this;
        this.httpClient.request(Links.APIPaymentsContributionsFormDataSave, "GET").then(function (response){
            _self.server = response;
            _self.setState({server: response, isLoadCompleted: true, hasError: response.code === 0, ...response.data});
        }).catch(function (error){
            _self.setState({showAlert: true, hasAsyncError: true});
        });
    }
}

export default ContributionsSave;